module.exports = __webpack_public_path__ + "static/media/grey-round-cross.99ab6baa.svg";